import React, { useState, useEffect, useRef } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { Document, Packer, Paragraph, Table, TableCell, TableRow } from "docx";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import TableChartIcon from "@mui/icons-material/TableChart";
import { useDispatch } from "react-redux";
import { setFilteredReports } from "../../../../../store/slices/filteredDataSlice";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import CommaConvert from "../../../../../utils/CommaConvert";
import { isWonLeadStatus } from "../../../../../utils/syncLeadProjectBucketStatus";

const SalesL1 = ({ showgraph, filteredReports = [] }) => {
  const popupRef = useRef(null);
  const currency = useCurrencySymbol();
  const dispatch = useDispatch();
  const USAComma = CommaConvert();

  const [topLeads, setTopLeads] = useState([]); // New state for top 10 leads
  const [, setIsGroupOpen] = useState(false);
  const [groupFilteredReports, setGroupFilteredReports] = useState([]);

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [probabilityTab, setProbabilityTab] = useState("graph");
  const [isDropdownVisibleRevenue, setIsDropdownVisibleRevenue] =
    useState(false);
  const [probabilityTabRevenue, setProbabilityTabRevenue] = useState("graph");
  const [groupedData, setGroupedData] = useState([]);

  useEffect(() => {
    if (filteredReports && Array.isArray(filteredReports)) {

      const wonLeads = filteredReports.filter((lead) =>
        isWonLeadStatus(lead.Status)
      );
      setGroupFilteredReports(wonLeads);
    }
  }, [filteredReports]);

  useEffect(() => {
    dispatch(setFilteredReports());
  }, [dispatch]);

  // useEffect(() => {
  //   if (groupFilteredReports && Array.isArray(groupFilteredReports)) {
  //     const top10SortedLeads = [...groupFilteredReports]
  //       .filter((lead) => typeof lead.QuotedValue === "number")
  //       .sort((a, b) => b.QuotedValue - a.QuotedValue)
  //       .slice(0, 10)
  //       .sort((a, b) => a.QuotedValue - b.QuotedValue);

  //     setTopLeads(top10SortedLeads); // Storing the data
  //   }
  // }, [groupFilteredReports]);
  useEffect(() => {
    if (groupFilteredReports && Array.isArray(groupFilteredReports)) {
      const top10SortedLeads = [...groupFilteredReports]
        .filter((lead) => Number.isFinite(Number(lead.QuotedValue)))
        .sort((a, b) => Number(b.QuotedValue) - Number(a.QuotedValue))
        .slice(0, 10)
        .sort((a, b) => Number(a.QuotedValue) - Number(b.QuotedValue));

      setTopLeads(top10SortedLeads);
    }
  }, [groupFilteredReports]);

  // useEffect(() => {
  //   const groupedObject = topLeads.reduce((acc, lead) => {
  //     const type = lead.TypeService || "Unknown";
  //     if (!acc[type]) {
  //       acc[type] = {
  //         TypeService: type,
  //         leads: [],
  //         totalQuotedValue: 0,
  //       };
  //     }
  //     acc[type].leads.push(lead);
  //     acc[type].totalQuotedValue += Number(lead.QuotedValue || 0);
  //     return acc;
  //   }, {});
  //   // Convert object to array
  //   const groupedArray = Object.values(groupedObject);
  //   setGroupedData(groupedArray);
  // }, [topLeads]);

  useEffect(() => {

    const groupedObject = topLeads.reduce((acc, lead) => {
      const type = lead.TypeService || "Unknown";
      if (!acc[type]) {
        acc[type] = {
          TypeService: type,
          leads: [],
          totalQuotedValue: 0,
        };
      }
      acc[type].leads.push(lead);
      acc[type].totalQuotedValue += Number(lead.QuotedValue || 0);
      return acc;
    }, {});
    const groupedArray = Object.values(groupedObject);
    setGroupedData(groupedArray);
  }, [topLeads, showgraph]);

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setIsDropdownVisibleRevenue(false); // Close the popup if clicked outside
    }
  };
  useEffect(() => {
    if (isDropdownVisibleRevenue) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDropdownVisibleRevenue]);
  const dropdownRefGroup = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefGroup.current &&
        !dropdownRefGroup.current.contains(event.target)
      ) {
        setIsGroupOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefclient = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefclient.current &&
        !dropdownRefclient.current.contains(event.target)
      ) {
        setIsDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible); // Toggle dropdown visibility
  };
  const handleDownload = (event) => {
    const value = event.target.value;

    if (value === "pdf") {
      downloadPDF();
    } else if (value === "word") {
      downloadWord();
    } else if (value === "excel") {
      downloadExcel();
    }
    setIsDropdownVisible(false);
  };


  const downloadPDF = () => {
    const doc = new jsPDF();
    const body = topLeads.map((LeadReport, index) => [
      index + 1,
      LeadReport.ClientName,
      `${currency}${USAComma(LeadReport.QuotedValue)}`,
    ]);

    const totalQuotedValue = topLeads.reduce(
      (sum, lead) => sum + Number(lead.QuotedValue),
      0
    );
    const formattedTotal = `${currency}${USAComma(totalQuotedValue)}`;

    // Generate the table with foot
    doc.autoTable({
      head: [["Sr.No", "Client Name", "Quoted Value"]],
      body: body,
      foot: [[" ", "Total", formattedTotal]], // Same structure as head
      styles: {
        fontSize: 7,
      },
      headStyles: {
        fontSize: 8,
      },
      footStyles: {
        fontSize: 8,
        fontStyle: "bold",
        fillColor: [220, 220, 220], // Optional: light gray background
      },
    });

    doc.save("LeadReports.pdf");
  };
  const downloadWord = () => {
    const headerRow = new TableRow({
      children: [
        new TableCell({ children: [new Paragraph("Sr.No")] }),

        new TableCell({ children: [new Paragraph("Client Name")] }),
        new TableCell({ children: [new Paragraph("Quoted Value")] }),
      ],
    });

    const dataRows = topLeads.map((LeadReport, index) => {
      return new TableRow({
        children: [
          new TableCell({ children: [new Paragraph(`${index + 1}`)] }),
          new TableCell({ children: [new Paragraph(LeadReport.ClientName)] }),
          new TableCell({
            children: [
              new Paragraph(
                `${currency} ${USAComma(LeadReport.QuotedValue)}`
              ),
            ],
          }),
        ],
      });
    });

    // 🔢 Calculate total quoted value
    const totalQuotedValue = topLeads.reduce(
      (sum, lead) => sum + Number(lead.QuotedValue),
      0
    );
    const formattedTotal = `${currency} ${USAComma(totalQuotedValue)}`;

    // ➕ Footer Row
    const footerRow = new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph("")],
          verticalAlign: "center",
        }),
        new TableCell({
          children: [new Paragraph("Total")],
          verticalAlign: "center",
        }),
        new TableCell({
          children: [new Paragraph(formattedTotal)],
          verticalAlign: "center",
        }),
      ],
    });

    const doc = new Document({
      sections: [
        {
          properties: {},
          children: [
            new Table({
              rows: [headerRow, ...dataRows, footerRow],
            }),
          ],
        },
      ],
    });

    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, "LeadReports.docx");
    });
  };
  const downloadExcel = () => {
    const sortedLeads = [...topLeads].sort(
      (a, b) => new Date(a.LeadDate) - new Date(b.LeadDate)
    );

    // Create data rows
    const data = sortedLeads.map((LeadReport, index) => ({
      "Sr.No": index + 1,
      "Client Name": LeadReport.ClientName,
      "Quoted Value": Number(LeadReport.QuotedValue), // Keep as number
    }));

    // ➕ Calculate total
    const totalQuotedValue = sortedLeads
      .reduce((sum, lead) => sum + Number(lead.QuotedValue), 0);

    // Add a total row at the bottom
    data.push({
      "Sr.No": "",
      "Client Name": "Total",
      "Quoted Value": USAComma(totalQuotedValue),
    });

    // Generate worksheet and workbook
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Lead Reports");

    // Save as Excel file
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelFile = new Blob([excelBuffer], {
      bookType: "xlsx",
      type: "application/octet-stream",
    });
    saveAs(excelFile, "LeadReports.xlsx");
  };
  const AllClient = () => {
    const sortedLeads = [...groupFilteredReports].sort(
      (a, b) => new Date(a.LeadDate) - new Date(b.LeadDate)
    );

    // Create data rows
    const data = sortedLeads.map((LeadReport, index) => ({
      "Sr.No": index + 1,
      "Client Name": LeadReport.ClientName,
      "Quoted Value": Number(LeadReport.QuotedValue), // Keep as number
    }));

    // ➕ Calculate total
    const totalQuotedValue = sortedLeads
      .reduce((sum, lead) => sum + Number(lead.QuotedValue), 0);

    // Add a total row at the bottom
    data.push({
      "Sr.No": "",
      "Client Name": "Total",
      "Quoted Value": USAComma(totalQuotedValue),
    });

    // Generate worksheet and workbook
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Lead Reports");

    // Save as Excel file
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelFile = new Blob([excelBuffer], {
      bookType: "xlsx",
      type: "application/octet-stream",
    });
    saveAs(excelFile, "LeadReports.xlsx");
  };

  const AllClientServiceType = () => {
    if (!groupFilteredReports || !Array.isArray(groupFilteredReports)) return;

    // Prepare data with only required columns
    const data = groupFilteredReports.map((lead) => ({
      TypeService: lead.TypeService?.join(", ") || "", // join array into string
      QuotedValue: lead.QuotedValue || "",
    }));

    // Convert to worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");

    // Generate Excel file and trigger download
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(dataBlob, "ClientServices.xlsx");
  };
  //for Revenue//
  const toggleDropdownRevenue = () => {
    setIsDropdownVisibleRevenue(!isDropdownVisibleRevenue); // Toggle dropdown visibility
  };
  const handleDownloadRevenue = (event) => {
    const value = event.target.value;

    if (value === "pdf") {
      downloadPDFRevenue();
    } else if (value === "word") {
      downloadWordRevenue();
    } else if (value === "excel") {
      downloadExcelRevenue();
    }
    setIsDropdownVisibleRevenue(false);
  };
  const downloadPDFRevenue = () => {
    const doc = new jsPDF();

    // Prepare table body
    const body = groupedData.map((LeadReport, index) => [
      index + 1,
      LeadReport.TypeService,
      `${currency}${USAComma(LeadReport.totalQuotedValue)}`,
    ]);

    // Calculate total
    const totalQuotedValue = groupedData.reduce(
      (sum, lead) => sum + Number(lead.totalQuotedValue),
      0
    );
    const formattedTotal = `${currency}${USAComma(totalQuotedValue)}`;

    // Generate the table with foot
    doc.autoTable({
      head: [["Sr.No", "Service Type", "Quoted Value"]],
      body: body,
      foot: [[" ", "Total", formattedTotal]], // Same structure as head
      styles: {
        fontSize: 7,
      },
      headStyles: {
        fontSize: 8,
      },
      footStyles: {
        fontSize: 8,
        fontStyle: "bold",
        fillColor: [220, 220, 220], // Optional: light gray background
      },
    });

    doc.save("LeadReports.pdf");
  };
  const downloadWordRevenue = () => {
    const headerRow = new TableRow({
      children: [
        new TableCell({ children: [new Paragraph("S.No")] }),

        new TableCell({ children: [new Paragraph("Service Type")] }),
        new TableCell({ children: [new Paragraph("Quoted Value")] }),
      ],
    });

    const dataRows = groupedData.map((LeadReport, index) => {
      return new TableRow({
        children: [
          new TableCell({ children: [new Paragraph(`${index + 1}`)] }),
          new TableCell({ children: [new Paragraph(LeadReport.TypeService)] }),
          new TableCell({
            children: [
              new Paragraph(
                `${currency}${USAComma(LeadReport.totalQuotedValue)}`
              ),
            ],
          }),
        ],
      });
    });

    // 🔢 Calculate total quoted value
    const totalQuotedValue = groupedData
      .reduce((sum, lead) => sum + Number(lead.totalQuotedValue), 0);
    const formattedTotal = `${currency}${USAComma(totalQuotedValue)}`;

    const footerRow = new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph("#")],
          verticalAlign: "center",
        }),
        new TableCell({
          children: [new Paragraph("Total")],
          verticalAlign: "center",
        }),
        new TableCell({
          children: [new Paragraph(formattedTotal)],
          verticalAlign: "center",
        }),
      ],
    });

    const doc = new Document({
      sections: [
        {
          properties: {},
          children: [
            new Table({
              rows: [headerRow, ...dataRows, footerRow],
            }),
          ],
        },
      ],
    });

    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, "LeadReports.docx");
    });
  };
  const downloadExcelRevenue = () => {

    const data = topLeads.map((LeadReport, index) => ({
      "Sr. No": index + 1,
      "Service Type": LeadReport.TypeService?.join(", ") || "",
      "Quoted Value": Number(LeadReport.QuotedValue), // Keep as number
    }));

    // ➕ Calculate total
    const totalQuotedValue = topLeads
      .reduce((sum, lead) => sum + Number(lead.QuotedValue), 0);

    data.push({
      "Sr.No": "",
      "Service Type": "Total",
      "Quoted Value": USAComma(totalQuotedValue),
    });

    // Generate worksheet and workbook
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Lead Reports");

    // Save as Excel file
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelFile = new Blob([excelBuffer], {
      bookType: "xlsx",
      type: "application/octet-stream",
    });
    saveAs(excelFile, "LeadReports.xlsx");
  };
  const COLORS = [
    "#1d72f3",
    "#3b8ef5",
    "#64a4f8",
    "#92c2fc",
    "#c6defe",
    "#a4d3f3",
    "#7fbff5",
    "#539af8",
    "#2e6ff3",
    "#1549e0",
  ];
  const data = topLeads.map((lead, index) => ({
    name: lead.ClientName || `Lead ${index + 1}`,
    value: lead.QuotedValue || 0,
  }));
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { name, value } = payload[0];
      const formattedValue = `${currency}${USAComma(value)}`;
      return (
        <div
          style={{
            background: "#fff",
            border: "1px solid #ccc",
            padding: "8px",
            borderRadius: "6px",
            boxShadow: "0px 0px 8px rgba(0,0,0,0.1)",
          }}
        >
          <p>
            <strong>{name}</strong>
          </p>
          <p>Quoted Value: {formattedValue}</p>
        </div>
      );
    }
    return null;
  };
  const COLORSrevenue = [
    "#1d72f3",
    "#3b8ef5",
    "#64a4f8",
    "#92c2fc",
    "#c6defe",
    "#a4d3f3",
    "#7fbff5",
    "#539af8",
    "#2e6ff3",
    "#1549e0",
  ];
  const datarevenue = groupedData.map((lead, index) => ({
    name: lead.TypeService || `Lead ${index + 1}`,
    value: lead.totalQuotedValue || 0,
  }));

  const CustomTooltiprevenue = ({ active, payload }) => {

    if (active && payload && payload.length) {
      const { name, value } = payload[0];
      const formattedValue = `${currency}${USAComma(value)}`;
      return (
        <div
          style={{
            background: "#fff",
            border: "1px solid #ccc",
            padding: "8px",
            borderRadius: "6px",
            boxShadow: "0px 0px 8px rgba(0,0,0,0.1)",
          }}
        >
          <p>
            <strong>{name.join(", ")}</strong>
          </p>
          <p>Quoted Value: {formattedValue}</p>
        </div>
      );
    }
    return null;
  };

  const highestQuotedLead = topLeads.reduce((max, lead) => {
    return lead.QuotedValue > (max?.QuotedValue || 0) ? lead : max;
  }, null);

  const highestQuotedGroup = groupedData.reduce((max, item) => {
    return item.totalQuotedValue > max.totalQuotedValue ? item : max;
  }, groupedData[0]);


  return (
    <div className="flex gap-3 w-full h-full ">
      <div
        className="px-3 pb-3 bg-white rounded-lg w-1/2 h-full justify-center  "
        style={{ fontFamily: "Lora", fontWeight: 600 }}
      >
        <div className="h-full">
          <div className="h-[10%]">
            <div className="w-full flex flex-wrap md:flex-nowrap justify-between items-center">
              <div className="w-full md:w-[70%] ">
                <h1 className="text-md font-semibold ">Top 10 Client</h1>
              </div>

              <div className="w-full md:w-[30%] flex items-center justify-end mt-2 md:mt-0">
                <div className="show-potential-download lg:justify-end ">
                  <div className=" inline-block relative px-3 mt-2">
                    <div
                      ref={dropdownRefclient}
                      className={`flex items-center text-4xl sm:text-md md:text-xl lg:text-xl xl:text-2xl 2xl:text-4xl ${topLeads.length === 0
                        ? "opacity-50 pointer-events-none"
                        : ""
                        }`}
                    >
                      <CloudDownloadIcon
                        onClick={toggleDropdown}
                        className="cursor-pointer"
                      // fontSize="4rem"
                      />

                      {isDropdownVisible && (
                        <div className="absolute top-8 -left-0 shadow-lg z-50 bg-white text-base">
                          <div
                            className="px-2 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() =>
                              handleDownload({ target: { value: "pdf" } })
                            }
                          >
                            PDF
                          </div>
                          <div
                            className="px-2 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() =>
                              handleDownload({ target: { value: "excel" } })
                            }
                          >
                            Excel
                          </div>
                          <div
                            className="px-2 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() =>
                              handleDownload({ target: { value: "word" } })
                            }
                          >
                            Word
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="show-potential-download lg:justify-end">
                  <div className=" flex items-center justify-between text-3xl sm:text-xl md:text-md">
                    {probabilityTab === "table" && (
                      <span title="Graph">
                        <SignalCellularAltIcon
                          className="cursor-pointer"
                          onClick={() => setProbabilityTab("graph")}
                          fontSize="3rem"
                        />
                      </span>
                    )}
                    {probabilityTab === "graph" && (
                      <span title="Table">
                        <TableChartIcon
                          className="cursor-pointer"
                          onClick={() => setProbabilityTab("table")}
                          fontSize="3rem"
                        />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <hr />
            <hr />
          </div>

          <div className="min-h-[80%] flex lg:pt-4 xl:pt-3">
            {probabilityTab === "table" ? (
              topLeads.length > 0 ? (
                <div className="w-full max-h-[14rem] overflow-scroll custom-scroll">
                  <div className="w-full flex sticky top-0">
                    <div className="w-[50%] text-center text-[0.6rem] bg-black text-white border px-1 py-1">
                      <p>Client</p>
                    </div>
                    <div className="w-[50%] text-center text-[0.6rem] bg-black text-white border px-1 py-1">
                      <p>Amount</p>
                    </div>
                  </div>

                  <div className="">
                    {topLeads
                      ?.slice() // clone so original state isn’t mutated
                      .sort((a, b) => b.QuotedValue - a.QuotedValue) // highest → lowest
                      .map((item, index) => (<div className="w-full flex" key={index}>
                        <div className="w-[50%] text-center text-[0.6rem] border px-1 py-1 break-words whitespace-normal">
                          {item.ClientName}
                        </div>
                        <div className="w-[50%] text-center text-[0.6rem] border px-1 py-1">
                          {currency}{USAComma(item.QuotedValue)}
                        </div>
                      </div>
                      ))}
                  </div>
                  <div className="w-full flex">
                    <div className="w-[50%] text-center text-[0.6rem] bg-black text-white border px-1 py-1">
                      <p>Total</p>
                    </div>
                    <div className="w-[50%]  text-center text-[0.6rem] truncate bg-black text-white border px-1 py-1">
                      <p className="truncate">
                        {currency}
                        {USAComma(Number(topLeads
                          .reduce(
                            (total, item) =>
                              total + Number(item.QuotedValue || 0),
                            0
                          )))}
                      </p>
                    </div>
                  </div>
                  <div>
                    <p
                      className="text-[#0070c0] py-0.5 cursor-pointer text-[0.6rem]"
                      onClick={AllClient}
                    >
                      See all*
                    </p>
                  </div>
                </div>
              ) : (
                <div className="flex justify-center align-middle items-center text-center mb-5  w-full">
                  <p className="noDataAvailable">
                    No data available
                  </p>{" "}
                </div>
              )
            ) : topLeads.length > 0 ? (
              <div className="relative w-full flex justify-center items-center ">
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={data}
                      cx="50%"
                      cy="50%"
                      innerRadius="30%"
                      outerRadius="60%"
                      fill="#8884d8"
                      dataKey="value"
                    >
                      {data.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                    <Tooltip content={<CustomTooltip />} />
                  </PieChart>
                </ResponsiveContainer>
                <div className="absolute bottom-2 flex gap-1">
                  {/* <p>{highestQuotedLead.ClientName}</p> */}
                  <p>{currency}{USAComma(highestQuotedLead.QuotedValue)}</p>
                </div>
              </div>
            ) : (
              <div className="flex justify-center align-middle items-center text-center mb-5  w-full">
                <p className="noDataAvailable">
                  No data available
                </p>{" "}
              </div>
            )}
          </div>
        </div>
      </div>


      <div
        className="px-3 pb-3 bg-white rounded-lg w-1/2 h-full justify-center "
        style={{ fontFamily: "Lora", fontWeight: 600 }}
      >
        <div className="h-full">
          <div className="h-[10%]">
            <div className="flex flex-wrap justify-start items-center xl:flex xl:justify-between md:justify-between md:flex-nowrap ">
              <div className="pb-2">
                <h1 className="text-md font-semibold">Revenue</h1>
              </div>

              <div className="md:flex lg:ml-8 lg:flex lg:items-center lg:justify-end xl:flex xl:justify-end">
                <div className="show-potential-download lg:justify-end ">
                  <div className=" inline-block relative px-3 mt-2">
                    <div
                      ref={popupRef}
                      className={`flex items-center text-4xl sm:text-md md:text-xl lg:text-xl xl:text-2xl 2xl:text-4xl ${groupedData.length === 0
                        ? "opacity-50 pointer-events-none"
                        : ""
                        }`}
                    >
                      <CloudDownloadIcon
                        onClick={toggleDropdownRevenue}
                        className="cursor-pointer"
                      />

                      {isDropdownVisibleRevenue && (
                        <div className="absolute top-8 -left-0 shadow-lg z-50 bg-white text-base">
                          <div
                            className="px-2 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() =>
                              handleDownloadRevenue({
                                target: { value: "pdf" },
                              })
                            }
                          >
                            PDF
                          </div>
                          <div
                            className="px-2 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() =>
                              handleDownloadRevenue({
                                target: { value: "excel" },
                              })
                            }
                          >
                            Excel
                          </div>
                          <div
                            className="px-2 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() =>
                              handleDownloadRevenue({
                                target: { value: "word" },
                              })
                            }
                          >
                            Word
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="show-potential-download lg:justify-end">
                  <div className=" flex items-center justify-between text-3xl sm:text-xl md:text-md">
                    {probabilityTabRevenue === "table" && (
                      <span title="Graph">
                        <SignalCellularAltIcon
                          className="cursor-pointer"
                          onClick={() => setProbabilityTabRevenue("graph")}
                          fontSize="3rem"
                        />
                      </span>
                    )}
                    {probabilityTabRevenue === "graph" && (
                      <span title="Table">
                        <TableChartIcon
                          className="cursor-pointer"
                          onClick={() => setProbabilityTabRevenue("table")}
                          fontSize="3rem"
                        />
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <hr />
            <hr />
          </div>

          <div className="min-h-[80%] flex lg:pt-4 xl:pt-3">
            {probabilityTabRevenue === "table" ? (
              topLeads.length > 0 ? (
                <div className="w-full">
                  <div className="max-h-[14rem] overflow-scroll custom-scroll">
                    <div className="w-full flex sticky top-0 z-[499]">
                      <div className="w-[50%] text-center bg-black text-white text-[0.6rem] border px-1 py-1">
                        <p>Service Type</p>
                      </div>
                      <div className="w-[50%] text-center bg-black text-white text-[0.6rem] border px-1 py-1">
                        <p>Amount</p>
                      </div>
                    </div>

                    <div className="">
                      {[...topLeads]  // copy so original array isn’t mutated
                        .sort((a, b) => b.QuotedValue - a.QuotedValue) // highest first
                        .map((item, index) => {
                          const serviceTypes = item.TypeService || [];
                          const isMultiple = serviceTypes.length > 1;
                          const displayText = isMultiple ? "Multiple" : serviceTypes[0] || "";

                          return (
                            <div className="w-full flex" key={index}>
                              <div
                                className={`w-[50%] ${isMultiple ? "cursor-default" : "cursor-default"} text-center text-[0.6rem] border px-1 py-1 break-words whitespace-normal relative group`}
                                title={isMultiple ? serviceTypes.join(", ") : displayText} // 👈 comma-separated
                              >
                                {displayText}
                              </div>

                              {/* QuotedValue Column */}
                              <div className="w-[50%] text-center text-[0.6rem] border px-1 py-1">
                                {currency}{USAComma(item.QuotedValue)}
                              </div>
                            </div>
                          );
                        })}
                    </div>

                    <div className="w-full flex">
                      <div className="w-[50%] text-center bg-black text-white text-[0.6rem] border px-1 py-1">
                        <p>Total</p>
                      </div>
                      <div className="w-[50%] text-center truncate bg-black text-white text-[0.6rem] border px-1 py-1">
                        <p>
                          {currency}
                          {USAComma(Number(groupedData
                            .reduce(
                              (total, item) =>
                                total + Number(item.totalQuotedValue || 0),
                              0
                            )))}
                        </p>
                      </div>


                    </div>

                    <div>
                      <p
                        className="text-[#0070c0] py-0.5 cursor-pointer text-[0.6rem]"
                        onClick={AllClientServiceType}
                      >
                        See all*
                      </p>
                    </div>

                  </div>

                </div>
              ) : (
                <div className="flex justify-center align-middle items-center text-center mb-5  w-full">
                  <p className="noDataAvailable">
                    No data available
                  </p>{" "}
                </div>
              )
            ) : groupedData.length > 0 ? (
              <div className="relative w-full flex justify-center items-center">
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={datarevenue}
                      cx="50%"
                      cy="50%"
                      innerRadius="30%"
                      outerRadius="60%"
                      fill="#8884d8"
                      dataKey="value"
                    >
                      {datarevenue.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORSrevenue[index % COLORSrevenue.length]}
                        />
                      ))}
                    </Pie>
                    <Tooltip content={<CustomTooltiprevenue />} />
                  </PieChart>
                </ResponsiveContainer>
                <div className="absolute bottom-2 flex gap-1">
                  {/* <p>Highest Revenue :-</p>  */}
                  <p>
                    {currency}
                    {USAComma(highestQuotedGroup.totalQuotedValue)}
                  </p>
                </div>
              </div>
            ) : (
              <div className="flex justify-center align-middle items-center text-center mb-5  w-full">
                <p className="noDataAvailable">
                  No data available
                </p>{" "}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesL1;
